import React from 'react';
import NavBar2 from '../Shared/NavBar2/NavBar2';

const Blog = () => {
    return (
        <div>
            <NavBar2/>
            <h2 className="mt-5 pt-5">Blog section under constraction .........</h2>
        </div>
    );
};

export default Blog;